<template>
  <div>
    <ib-charts-placeholder v-if="isStartupCostsEmpty" />
    <el-tabs
      v-else
      v-model="activeTab"
      class="mb-3 tabs"
    >
      <!-- Timeline -->
      <el-tab-pane
        :label="$t('timeline')"
        name="first"
        lazy
      >
        <div class="bg-white">
          <startup-costs-over-time
            v-if="activeTab === 'first'"
            class="pt-4 pb-1"
            chart-animations
          />
        </div>
      </el-tab-pane>
      <!-- /Timeline -->

      <!-- Breakdown -->
      <el-tab-pane
        :label="$t('breakdown')"
        name="second"
        lazy
      >
        <div class="bg-white">
          <distribution-of-startup-costs
            v-if="activeTab === 'second'"
            class="pt-4 pb-1"
            chart-animations
          />
        </div>
      </el-tab-pane>
      <!-- /Breakdown -->

      <!-- Table -->
      <el-tab-pane
        :label="$t('table')"
        name="third"
        lazy
      >
        <div class="bg-white pt-4 pb-2">
          <startup-costs-table
            :table-rows-to-expand="tableRowsToExpand"
            :table-adjustment="tableAdjustment"
          />
        </div>
      </el-tab-pane>
      <!-- /Table -->
    </el-tabs>
  </div>
</template>

<script>
import DistributionOfStartupCosts from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/StartupCost/DistributionOfStartupCosts.vue'
import StartupCostsOverTime from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/StartupCost/StartupCostsOverTime.vue'
import StartupCostsTable from '@/views/Home/StoryMode/SetUp/StartupCosts/Tables/StartupCostsTable.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'StartupCostsTabs',

  components: {
    StartupCostsOverTime,
    DistributionOfStartupCosts,
    StartupCostsTable
  },

  data () {
    return {
      activeTab: 'first',
      tableRowsToExpand: [],
      tableAdjustment: {
        journalPage: false,
        period: 'monthly',
        tableFirstColumnWidth: 250,
        columnWidth: 118
      }
    }
  },

  computed: {
    ...mapGetters('idea', {
      startupCosts: 'getStartupCosts'
    }),

    isStartupCostsEmpty () {
      return this.startupCosts.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
.tabs {
  ::v-deep {
    .el-tabs__content {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 0 0 8px 8px;
    }
  }
}
</style>
